import { createRouter, createWebHistory } from "vue-router";
import routes from "./routes";

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition; // Restore previous scroll position on back/forward
        } else if (to.hash) {
            return {
                el: to.hash, // Scroll to element by hash
                behavior: 'smooth' // Optional: smooth scroll
            };
        } else {
            return {
                top: 0, // Scroll to top for new navigations
                behavior: 'smooth' // Optional: smooth scroll
            };
        }
    },
  });
  
  export default router;
